import React from 'react';
import { FaCheckCircle, FaClock, FaTimesCircle } from 'react-icons/fa';

export default function RecentTransactions({ transactions }) {
    const getStatusBadge = (status) => {
        switch (status) {
            case 'Approved':
                return <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-bold"><FaCheckCircle /> Approved</span>;
            case 'Pending':
                return <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-bold"><FaClock /> Pending</span>;
            case 'Rejected':
                return <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-bold"><FaTimesCircle /> Rejected</span>;
            default:
                return null;
        }
    };

    return (
        <div className="bg-white/60 backdrop-blur-xl rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white/50 p-6 h-full">
            <h2 className="text-lg font-bold text-gray-900 mb-6">Recent Transactions</h2>
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="text-xs text-gray-400 uppercase tracking-wider font-bold text-left border-b border-gray-100">
                        <tr>
                            <th className="pb-3 pl-2">Student</th>
                            <th className="pb-3">Date</th>
                            <th className="pb-3">Amount</th>
                            <th className="pb-3">Status</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {transactions && transactions.map((tx) => (
                            <tr key={tx.id} className="text-sm font-medium text-gray-600 hover:bg-white/50 transition-colors">
                                <td className="py-4 pl-2 font-bold text-gray-900">{tx.student_name}</td>
                                <td className="py-4">{new Date(tx.created_at).toLocaleDateString()}</td>
                                <td className="py-4">LKR {Number(tx.amount).toLocaleString()}</td>
                                <td className="py-4">{getStatusBadge(tx.status)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {(!transactions || transactions.length === 0) && (
                    <p className="text-center text-gray-400 text-sm py-4">No recent transactions</p>
                )}
            </div>
        </div>
    );
}
